var map = {
	"./components/components.module": [
		"../../../../../src/app/components/components.module.ts",
		"components.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./pages/pages.module": [
		"../../../../../src/app/pages/pages.module.ts",
		"pages.module"
	],
	"./timeline/timeline.module": [
		"../../../../../src/app/timeline/timeline.module.ts",
		"timeline.module"
	],
	"./userpage/user.module": [
		"../../../../../src/app/userpage/user.module.ts",
		"user.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main